import { EventTypes } from 'redux-segment';

const tracked = (...args) => {
  const isShort = 2 > args.length;

  // if two arguments are passed in, they are [payload,action]
  // otherwise a single argument (or none) is passed in, it is [action]
  const action = isShort ? args[0] : args[1];
  const payload = isShort ? void 1 : args[0];

  const a = { ...(action ?? {}) };

  a.meta = a.meta ?? {};
  a.meta.analytics = isShort ? EventTypes.track : { eventType: EventTypes.track, eventPayload: payload };

  return a;
};

export default tracked;
